<template>
  <general-tour
      name="EmployeeFirstLoginTour"
      :steps="steps"
      @onNextStep="nextStep"
  />
</template>

<script>
import GeneralTour from '../../shared/tour/GeneralTour'

export default {
  name: 'EmployeeFirstLoginTour',
  components: { GeneralTour },
  props: {
    additionalStepsArray: {
      required: true,
    },
  },

  data () {
    return {
      window,
      small: 767,
    }
  },

  computed: {
    registration () {
      return this.window.width < this.small ? '[data-v-step="employee-first-login-nav-small"]' : '[data-v-step="employee-first-login-nav"]'
    },
    account () {
      return this.window.width < this.small ? '[data-v-step="employee-first-login-account-small"]' : '[data-v-step="employee-first-login-account"]'
    },
    feedback () {
      return this.window.width < this.small ? '[data-v-step="employee-first-login-feedback-small"]' : '[data-v-step="employee-first-login-feedback"]'
    },
    notifications () {
      return this.window.width < this.small ? '[data-v-step="employee-first-login-notifications-small"]' : '[data-v-step="employee-first-login-notifications"]'
    },
    search () {
      return '[data-v-step="employee-first-login-search"]'
    },

    steps () {
      let steps = [{
        target: '[data-v-step="employee-first-login-start"]', // We're using document.querySelector() under the hood
        content: Lang.get('tours.employee_first_login.start'),
        params: {
          placement: 'bottom',
        },
      },
      ]

      if (this.additionalStepsArray['has_lecturers'] === true) {
        steps = steps.concat([{
          target: '[data-v-step="employee-first-login-calendar"]',
          content: Lang.get('tours.employee_first_login.calendar'),
          offset: -200,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="employee-first-login-calendar-full"]',
          content: Lang.get('tours.employee_first_login.calendar_full'),
          offset: -200,
          params: {
            placement: 'top',
          },
        },
      ])}

      // if (this.additionalStepsArray['program'] === true) {
      steps = steps.concat([{
        target: '[data-v-step="employee-first-login-program"]',
        content: Lang.get('tours.employee_first_login.program'),
        offset: -200,
        params: {
          placement: this.window.width < this.small ? 'bottom' : 'left',
        },
      },
      ])
      // }

      if (this.additionalStepsArray['lesson_feedback'] === true) {
        steps = steps.concat([{
          target: '[data-v-step="employee-first-login-lesson-feedback"]',
          content: Lang.get('tours.employee_first_login.lesson_feedback'),
          offset: -200,
          params: {
            placement: 'top',
          },
        }])
      }
      if (this.additionalStepsArray['mentor_students'] === true) {
        steps = steps.concat([{
          target: '[data-v-step="employee-first-login-mentor-students"]',
          content: Lang.get('tours.employee_first_login.mentor_students'),
          offset: -200,
          params: {
            placement: 'top',
          },
        }])
      }

      if (this.window.width < this.small) {
        steps = steps.concat([{
          target: '[data-v-step="employee-first-login-nav-small"]',
          content: Lang.get('tours.employee_first_login.nav_small'),
          params: {
            placement: 'bottom',
          },
        }])
      }

      if (this.additionalStepsArray['has_lecturers'] === true) {
        steps = steps.concat([{
          target: this.registration,
          content: Lang.get('tours.employee_first_login.registration'),
          params: {
            placement: this.window.width < this.small ? 'bottom' : 'right',
          },
        }])
        }

      if (this.additionalStepsArray['key'] === true) {
        steps = steps.concat([{
          target: this.registration,
          content: Lang.get('tours.employee_first_login.key'),
          params: {
            placement: this.window.width < this.small ? 'bottom' : 'right',
          },
        }])
      }

      steps = steps.concat([{
        target: this.account,
        content: Lang.get('tours.employee_first_login.account'),
        offset: this.window.width < this.small ? 0 : top,
        params: {
          placement: this.window.width < this.small ? 'top' : 'left',
        },
      }])

      if (this.window.width > this.small) {
        steps = steps.concat([{
          target: '[data-v-step="employee-first-login-search"]',
          content: Lang.get('tours.employee_first_login.search'),
          params: {
            placement: 'bottom',
          },
        }])
      }

      if (this.additionalStepsArray['notifications'] === true) {
        steps = steps.concat([{
          target: this.notifications,
          content: Lang.get('tours.employee_first_login.notifications'),
          params: {
            placement: this.window.width < this.small ? 'top' : 'bottom',
          },
        }])
      }

      steps = steps.concat([
        {
          target: this.feedback,
          content: Lang.get('tours.employee_first_login.feedback'),
          params: {
            placement: this.window.width < this.small ? 'top' : 'bottom',
          },
        },
        {
          target: '[data-v-step="employee-first-login-end"]',
          content: Lang.get('tours.employee_first_login.end'),
          params: {
            placement: 'bottom',
            isLast: true,
          },
        }])
      return steps
    }
    ,
  },

  methods: {
    nextStep (currentStep) {
      let progress_step = currentStep + 1

      let slide_in = $('.slide-in')

      if (this.window.width < this.small) {
        // slide in or slide out the navigation menu
        if (this.steps[progress_step].target === '[data-v-step="employee-first-login-nav-small"]' && slide_in.length == 0) {
          $('#btn-sidebar-event').click()
        } else if (this.steps[progress_step].params.isLast && slide_in.length == 1) {
          $('#btn-sidebar-event').click()
        }
      }
    },
  },
}
</script>
